import s from "./_baseEach.js";
import u from "./isArrayLike.js";
function o(r, e) {
  var t = -1, a = u(r) ? Array(r.length) : [];
  return s(r, function(f, i, n) {
    a[++t] = e(f, i, n);
  }), a;
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseMap.js
// module id = 1438
// module chunks = 41